import { Flex } from "antd";
import styled from "styled-components";

export const ButtonsWrapper = styled(Flex)<{ $hasBackground: boolean }>`
  gap: 10px;
  background-color: ${({ theme, $hasBackground }) =>
    $hasBackground ? theme.colorBgContainerDisabled : "transparent"};
  padding: 4px 8px;
  border: 1px solid transparent;
  border-radius: 5px;
  justify-content: space-between;
`;
